import { Inject, Injectable, InjectionToken } from '@angular/core';
import { SeveralSettingsBoxSettings } from 'estensa-module';
import { Observable, from } from 'rxjs';
import { CacheService } from '../../utils/cache.service';

export const ESTENSA_MODULE_SEVERAL_SETTINGS_BOX_SETTINGS_SERVICE = new InjectionToken(
    'estensa.module.several.settings.box.service',
);

@Injectable({
    providedIn: 'root',
})
export class SeveralSettingsBoxSettingsService {
    constructor(
        @Inject(ESTENSA_MODULE_SEVERAL_SETTINGS_BOX_SETTINGS_SERVICE) private settingsService,
        private cacheService: CacheService,
    ) {}

    getSettings(): Observable<SeveralSettingsBoxSettings> {
        return this.cacheService.get(
            'SeveralSettingsBoxSettings',
            from(this.settingsService.getAsJSON() as Promise<SeveralSettingsBoxSettings>),
        );
    }
}
